"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dummyAuthority = exports.SPACE_BUFFER = exports.DID_REGISTRY_PROGRAM_ID = void 0;
const web3_js_1 = require("@solana/web3.js");
exports.DID_REGISTRY_PROGRAM_ID = new web3_js_1.PublicKey("regUajGv87Pti6QRLeeRuQWrarQ1LmEyDXcAozko6Ax");
exports.SPACE_BUFFER = 1; // increase registry size by this whenever resizing
// Use this to pass a non-signing wallet into read-only registries
exports.dummyAuthority = {
    publicKey: new web3_js_1.PublicKey("11111111111111111111111111111111"),
    signTransaction: () => __awaiter(void 0, void 0, void 0, function* () {
        throw new Error("Not implemented");
    }),
    signAllTransactions: () => __awaiter(void 0, void 0, void 0, function* () {
        throw new Error("Not implemented");
    }),
};
//# sourceMappingURL=constants.js.map